import Translation from '../../../lang/Translation';
import CheckoutOverlay from '../CheckoutOverlay';

function PayerNameOverlay() {
  return (
    <CheckoutOverlay
      popup
      title="checkout.address.field.label.payer.name.text"
    >
      <Translation>payer.name.tooltip.advice</Translation>
    </CheckoutOverlay>
  );
}

export default PayerNameOverlay;
